module.exports = __webpack_public_path__ + "static/bag_of_beans-2d5852d66a0fd2d622ce400e4534dc7d.jpeg";